function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-artist"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.681,1.317 C13.8397186,0.471098439 12.6950189,-0.00312913808 11.502,0 C10.301,0 9.172,0.468 8.322,1.317 C6.56849607,3.07401813 6.56849607,5.91898187 8.322,7.676 C9.16352547,8.5221484 10.3086347,8.99639648 11.502,8.993 C12.703,8.993 13.832,8.525 14.682,7.676 C16.4361694,5.91886676 16.4361694,3.07313324 14.682,1.316 L14.681,1.317 Z M9.246,9.335 C9.238,9.331 8.356,8.968 7.693,8.305 C7.033,7.645 6.667,6.761 6.663,6.752 C6.543,6.456 6.313,6.28 6.048,6.28 C5.854,6.28 5.661,6.377 5.504,6.552 L0.256,12.442 C-0.0983696655,12.84899 -0.0809663643,13.4598458 0.296,13.846 L0.69,14.24 L0.25,14.68 C-0.0279685999,14.9777098 -0.0201168945,15.4421173 0.267756679,15.7302604 C0.555630253,16.0184035 1.02003021,16.0266899 1.318,15.749 L1.758,15.309 L2.152,15.703 C2.34,15.89 2.604,15.998 2.876,15.998 C3.13,15.998 3.371,15.908 3.556,15.743 L9.446,10.494 C9.653,10.31 9.749,10.076 9.71,9.852 C9.671,9.628 9.502,9.439 9.246,9.335 Z M6.358,11.057 L5.849,11.567 C5.545,11.871 5.149,12.052 4.792,12.052 C4.56513294,12.0589774 4.34509808,11.9738492 4.182,11.816 C3.785,11.419 3.895,10.686 4.432,10.149 L4.941,9.64 C5.245,9.336 5.641,9.154 5.998,9.154 C6.22486706,9.14702258 6.44490192,9.23215082 6.608,9.39 C7.005,9.788 6.895,10.52 6.358,11.057 Z",
  id: "Shape"
}))));

var SvgArtist = function SvgArtist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArtist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/artist.c85fc213.svg";
export { ForwardRef as ReactComponent };